import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Llegué al día 5 sin Endo-Belly por primera vez en años. No lo podía creer.',
  author: 'Valentina M.',
  details: '31 años, Buenos Aires'
}, {
  quote: 'El Bonus del Botón de Pánico lo tengo pegado en la heladera. Me salvó dos crisis seguidas.',
  author: 'Lucía R.',
  details: '27 años, Córdoba'
}, {
  quote: 'Por fin algo que entiende que no puedo comprar semillas de chía importadas. Todo con lo que hay en el Coto de mi barrio.',
  author: 'Florencia D.',
  details: '35 años, Rosario'
}, {
  quote: 'Pude volver a trabajar sin tener que tomarme el día por el dolor. La desinflamación que logré en dos semanas es increíble.',
  author: 'Camila S.',
  details: '28 años, Mendoza'
}, {
  quote: 'El plan de comidas es súper fácil de seguir. Nada de ingredientes raros, todo lo compré en el súper de la esquina y me siento con más energía que nunca.',
  author: 'Martina L.',
  details: '33 años, Tucumán'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-marfil py-16 px-5 flex justify-center" data-id="element-134">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-50px'
    }} className="w-full max-w-md flex flex-col gap-8" data-id="element-135">
        <h2 className="font-serif font-bold text-petroleo text-3xl leading-tight text-center" data-id="element-136">
          Lo que dicen las mujeres que ya lo hicieron:
        </h2>

        <div className="flex flex-col gap-4" data-id="element-137">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-5 rounded-2xl shadow-sm border border-salvia-light flex flex-col gap-3" data-id="element-138">
              <div className="flex gap-1" data-id="element-139">
                {[...Array(5)].map((_, index) => <Star key={index} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-140" />)}
              </div>
              <p className="text-gray-800 text-base font-medium leading-snug italic" data-id="element-141">
                "{t.quote}"
              </p>
              <div className="mt-1" data-id="element-142">
                <p className="font-bold text-petroleo text-sm" data-id="element-143">{t.author}</p>
                <p className="text-xs text-gray-500" data-id="element-144">{t.details}</p>
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}